import type { AiContextType, AiRouteContext } from 'services/aiService'

/**
 * Prompts to offer for what the user is looking at (MYD-621, MYD-622).
 *
 * Keyed on the route's asset (useRouteAssetContext), so "this project" is
 * only suggested where there is a project for it to mean, including a
 * project reached through its location, or an Explorer report scoped to one.
 *
 * Questions Ask MDT can answer TODAY: it reads, it does not yet change
 * anything (plans arrive with MYD-620). "Add a project…" and its kind join
 * this list when they can be carried out.
 */

const BY_ASSET: Record<AiContextType, string[]> = {
	project: ["What's overdue on this project?", 'Who is working on this project, and on what?', 'Summarise where this project stands.'],
	location: ['Summarise this location.', 'What projects are running here?', 'Which tasks here are due this week?'],
	portfolio: ['Give me an overview of this portfolio.', 'Which locations here are largest?', 'Which tasks across this portfolio are overdue?'],
	evaluation: ['Which site scores best, and why?', 'Compare the sites on their financials.', 'What are the biggest risks in this evaluation?'],
}

const ANYWHERE = ['What tasks are assigned to me?', 'Which of my evaluations are under review?', 'How many locations do I have?']

export const suggestionsFor = (context: AiRouteContext | null): string[] => (context ? BY_ASSET[context.type] : ANYWHERE)
